import { connect } from 'react-redux'
import { getWhoAmI } from '../../common/auth/authActions'
import {
  appleHealthIntegration,
  initialAppleHealthIntegration,
  setIntegration,
} from '../../common/integration/integrationActions'
import { IGlobalState } from '../../Root/store/appReducer'
import { getUserCompanyCountries, getCompanyDivisions, updateUser } from '../Settings/store/SettingsActions'
import { RegisterUser } from './RegisterUser'
import {
  registerAppleHealth,
  registerUser,
  registerWithoutIntegration,
  updateActivityData,
  updateProfileData,
} from './store/RegisterUserActions'
import { getAuthData, getUserCompanies } from './store/RegisterUserSelectors'
import { reLocate } from '../../common/Routes/RouterActions'
import { companyCountriesSelector, companyDivisionsSelector } from '../Settings/store/SettingsSelectors'
import { getUserIntegrationScopes } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState) => ({
  userDto: getAuthData(state),
  userCompanies: getUserCompanies(state),
  countries: companyCountriesSelector(state),
  divisions: companyDivisionsSelector(state),
  userIntegrationScopes: getUserIntegrationScopes(state),
})

const mapDispatchToProps = {
  getWhoAmI,
  registerUser,
  setIntegration,
  appleHealthIntegration,
  initialAppleHealthIntegration,
  updateUser,
  registerAppleHealth,
  registerWithoutIntegration,
  reLocate,
  getUserCompanyCountries,
  getCompanyDivisions,
  updateProfileData,
  updateActivityData,
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUser)
